import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, message, Modal, Space } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import axios from 'axios';
import React from 'react';

import AddOrEditCleanKind from '../../AddOrEditCleanKind';
import CleanKindDetail from '../../CleanKindDetail';
import type {
  CleanKindResult,
  ReservationRuleFormValues,
} from '../../sharedTypes';

const { confirm } = Modal;

const deleteCleanKind = async (cleanKindId: string) => {
  try {
    await axios({
      method: 'DELETE',
      url: '/ezcon/api/removeCleanKind',
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
      params: {
        cleanKindId,
      },
    });
    message.success('刪除清潔類別成功!');
  } catch (error) {
    message.error('刪除清潔類別失敗!');
  }
};

const showDeleteConfirm = (cleanKindId: string, getLatestData: () => void) => {
  confirm({
    title: '確定刪除清潔類別？',
    content: '刪除後將無法復原!!',
    icon: <ExclamationCircleOutlined />,
    onOk: async () => {
      await deleteCleanKind(cleanKindId);
      getLatestData();
    },
  });
};

export const getCleanKindColumns = (
  cleanKindRules: ReservationRuleFormValues | undefined,
  getLatestData: () => void
) => {
  const columns: ColumnsType<CleanKindResult> = [
    {
      title: '類別',
      dataIndex: 'name',
    },
    {
      title: '所屬計費方案',
      width: 250,
      dataIndex: 'subscriptionPlanNameList',
      render: (value) => value.join('/'),
    },
    {
      title: '清潔人員',
      dataIndex: 'janitorKind',
    },
    {
      title: '合作廠商人員',
      dataIndex: 'partnerName',
    },
    {
      title: '免費項目',
      dataIndex: 'freeServiceName',
    },
    {
      title: '付費項目數量',
      dataIndex: 'nonFreeServiceCount',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 200,
      fixed: 'right',
      render: (_value, record) => {
        return (
          <Space>
            <CleanKindDetail
              record={record}
              mustCancelBeforeValues={{
                value: cleanKindRules?.mustCancelBeforeNumber,
                unit: cleanKindRules?.mustCancelBeforeUnit,
              }}
            />
            <AddOrEditCleanKind
              type="edit"
              record={record}
              getLatestData={getLatestData}
            />
            <Button
              type="primary"
              danger
              onClick={() =>
                showDeleteConfirm(record.cleanKindId, getLatestData)
              }
            >
              刪除
            </Button>
          </Space>
        );
      },
    },
  ];

  return columns;
};
